import { render, staticRenderFns } from "./HolidaysList.vue?vue&type=template&id=1095101d&scoped=true"
import script from "./HolidaysList.vue?vue&type=script&lang=js"
export * from "./HolidaysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095101d",
  null
  
)

export default component.exports